// frontend/src/components/Artists/ArtistList.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import ArtistCard from "./ArtistCard";
import LoadingSpinner from "../common/LoadingSpinner";
import ErrorMessage from "../common/ErrorMessage";

import "./ArtistList.css";

const ArtistList = () => {
  const navigate = useNavigate();
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadArtists = async () => {
      try {
        setLoading(true);
        const data = await api.getArtists();
        setArtists(data.artists || data);
        setError(null);
      } catch (err) {
        setError("Failed to load artists. Please try again later.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadArtists();
  }, []);

  const handleSelectArtist = (artist) => {
    navigate(`/artist/${artist._id}`);
  };

  if (loading) {
    return <LoadingSpinner message="Loading artists..." />;
  }

  if (error) {
    return (
      <ErrorMessage message={error} onRetry={() => window.location.reload()} />
    );
  }

  return (
    <div className="artist-list-main">
      <div className="artist-list-content">
        <h1 className="artist-list-title">Our Artists</h1>
        <p className="artist-list-subtitle">
          Meet the talented artists behind our collections
        </p>

        <div className="artists-grid">
          {artists.map((artist) => (
            <ArtistCard
              key={artist._id}
              artist={artist}
              onClick={() => handleSelectArtist(artist)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArtistList;
